import React, { useEffect } from "react";
import {
  I2cAccordion,
  I2cBadge,
  I2cIcon,
  I2cFormatDate,
} from "@webcomponents/i2cwebcomponents/dist/react";
import ProgramInformationOverview from "../PrepaidComponents/ReviewSummary/ProgramInformationOverview";
import ProjectInformationOverview from "../PrepaidComponents/ReviewSummary/ProjectInformationOverview";
import CompanyProfileOverview from "../PrepaidComponents/ReviewSummary/CompanyProfileOverview";
import CardNetworkAndBinInfoOverview from "../PrepaidComponents/ReviewSummary/CardNetworkAndBinInfoOverview";
import ChannelsOverview from "../PrepaidComponents/ReviewSummary/ChannelsOverview";
import ProgramFeaturesOverview from "../PrepaidComponents/ReviewSummary/ProgramFeaturesOverview";
import OptionalFeaturesOverview from "../PrepaidComponents/ReviewSummary/OptionalFeaturesOverview";
import InterfacesAndComponentsOverview from "../PrepaidComponents/ReviewSummary/InterfacesAndComponentsOverview";
import AdditionalCommentsOverview from "../PrepaidComponents/ReviewSummary/AdditionalCommentsOverview";
import ProgramFeaturesCreditOverview from "../PrepaidComponents/ReviewSummary/ProgramFeaturesCredit/index";
import SignoffOverview from "../PrepaidComponents/ReviewSummary/SignoffOverview";
import SalesService from "../../Services/SalesService";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getBadgeVariant } from "../../Utils/stringUtls";
import { extractKeyValues } from "../Users/UserProjects";
import { statuses } from "../SalesRequest/SingleSalePreview";
import { OverlayLoader } from "../../Components/Loader/Loader";

const ViewFormSummary = ({}) => {
  const { id: formId } = useParams();
  const type = window.location.pathname.split("/")[1];
  const clientUser = localStorage.getItem("userRole") === "5" ?? false;
  useEffect(() => {
    handleAccordion();
  }, []);
  const navigate = useNavigate();

  function handleAccordion() {
    const container = document.querySelector(".accordion-group-example");
    container?.addEventListener("i2c-show", (event) => {
      const accordion = container.querySelectorAll("i2c-accordion");
      for (let i = 0; i < accordion.length; i++) {
        if (accordion[i] !== event.target) {
          accordion[i].open = false;
        }
      }
    });
  }

  const fetchSingleSale = async () => {
    if (formId) {
      const res = await SalesService.fetchSale(formId);
      return res.data.data[0];
    }
    return null;
  };

  // Fetch sessions data using React Query hook
  const queryKey = ["form-review", formId];

  useEffect(() => {
    refetch();
  }, []);
  const {
    data: singleForm,
    refetch,
    isFetching,
    isLoading,
  } = useQuery(queryKey, fetchSingleSale, {
    enabled: !!formId, // Only fetch if formId is present,
    staleTime: Infinity,
  });

  const formData = JSON.parse(singleForm?.form_data ?? "{}");
  const formType = JSON.parse(singleForm?.form_type ?? "{}");
  if (Object.keys(formData)?.length === 0) return null;
  const signatureFormData = JSON.parse(singleForm?.signature ?? "{}");
  const showFormSignature = clientUser
    ? true
    : singleForm?.form_status_id === 4;

  const css = `
  .review-form-header {
		color: var(--colors-foreground-fg-primary-900, #121521);
		padding-top: var(--i2c-spacing-3);
		h2 {
			font-size: var(--i2c-font-size-display-xs);
			color: var(--text-primary-900);
			font-family: Inter;
			font-style: normal;
			font-weight: var(--i2c-font-weight-bold);
			line-height: var(--i2c-line-height-1-33);
			margin: 0 0 var(--i2c-spacing-6) 0;
		}
	}

  .accordion-container{
    margin-bottom:0px;
  }

  .accordion-container::part(base) {
    padding:0 var(--i2c-spacing-6) 0 var(--i2c-spacing-6) ;
  }

  .accordion-container::part(summary) {
    font-family: Inter;
    font-size: var(--i2c-font-size-text-lg);
    font-weight: var(--i2c-font-weight-medium);
    line-height: var(--i2c-line-height-1-5);
  }
  
  .accordion-container::part(header) {
    border-bottom: 2px solid var(--border-secondary);
    margin-bottom: var(--i2c-spacing-1);
    padding:var(--i2c-spacing-2) 0px var(--i2c-spacing-6) 0px; 
    margin-bottom: var(--i2c-spacing-4);
    
  }

  .accordion-container::part(content) {
    border-bottom: 2px solid var(--border-secondary);    
    margin-bottom:var(--i2c-spacing-4);
    
  }

  .border-less-container::part(header){
    padding-top:var(--i2c-spacing-4);
    border-top: 0;
  }

  .sale-overview-parent{
      padding: var(--i2c-spacing-6);
      background: var(--bg-primary_alt);
      border-bottom: 2px solid var(--border-secondary);    
  }

  .single-sale-inner1{
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      margin-bottom: var(--i2c-spacing-6);
    }
    @media (max-width: 466px) {
      flex-direction: column;
    }
  }

  .single-sale-name{
    display:flex;
    .project-name{
      font-size: var(--i2c-font-size-text-xl);
      font-weight: var(--i2c-font-weight-bold);
      line-height: var(--i2c-line-height-1-3);
    }
  }

  .single-sale-inner-child{
    display:flex;
    align-items:center;
    gap:var(--i2c-spacing-3);
    min-width:250px;
  }
`;

  const variant = getBadgeVariant(formData?.form_status_id);
  const keysToExtract = [
    "pd_client_name",
    "pi_program_type",
    "pi_program_name",
    "pd_region",
    "pd_team_avail",
    "pd_go_live",
    "ci_businessName",
    "ci_companyPhone",
    "cp_fi_fi_name",
    "cp_fi_phone_num",
  ];

  const extractedData = extractKeyValues([...formData], keysToExtract);
  const saleData = {};
  extractedData.forEach((obj) => {
    const [key, value] = Object.entries(obj)[0];
    saleData[key] = value;
  });

  if (isFetching || isLoading)
    return <OverlayLoader style={{ height: `calc(100vh - 125px)` }} />;

  return (
    <React.Fragment>
      <style>{css}</style>
      <div className="layout_aside_logged_user user-form-container">
        <div onClick={() => navigate(-1)} className="go-back-button">
          <I2cIcon
            name="cs-linear-chevron-left"
            label="icon"
            library="default"
            className="go-back-button-icon"
          />
          Back
        </div>
        <div className="review-form-header">
          <h2>Review Summary</h2>
        </div>
        <div className="accordion-group-example" style={{ width: "100%" }}>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="12">
              <div className=" users-listing-section-single-user">
                <div className="sale-overview-parent">
                  <div className="single-sale-inner1">
                    {/* Project Details */}
                    <div className="single-sale-inner-child">
                      <div className="single-sale-detail">
                        {/* Project Name and status */}
                        <div className="single-sale-name">
                          <strong className="project-name">
                            {saleData?.pi_program_name ?? "-"}
                            {extractedData.pd_client_name}
                          </strong>
                          <I2cBadge variant={`light-${variant}`} size="small">
                            {statuses[singleForm.form_status_id - 1]}
                          </I2cBadge>
                        </div>
                        {/* User Name & Creation Date */}
                        <div className="project-user-name-date">
                          <span>By {singleForm.added_by}</span>
                          <div className="date-holder">
                            <I2cFormatDate
                              month="short"
                              day="numeric"
                              year="numeric"
                              date={singleForm.created_at}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="single-sale-inner-child">
                      <I2cAvatar
                        initials="or"
                        label="Avatar with initials: i2c"
                        size="xLarge"
                        className="single-sale-avatar"
                        // image={`data:image/jpeg;base64,${user.avatar}`}
                      />

                      <div className="single-sale-detail">
                        <div className="single-sale-name">
                          <div>Danyyal</div>
                          <div className="single-sale-dept-badge">
                            <I2cBadge variant="light-primary" size="small">
                              Sales
                            </I2cBadge>
                          </div>

                        </div>
                        <div className="single-sale-date">
                          Project Manager - CIG
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Program Information"
                variant="borderless"
                className="accordion-container border-less-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <ProgramInformationOverview type={type} data={formData["0"]} />
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Project Information"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <ProjectInformationOverview data={formData["1"]} />
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Company Profile"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <CompanyProfileOverview data={formData["2"]} type={type} />
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Card Network And Bin Info"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <CardNetworkAndBinInfoOverview data={formData["3"]} />
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Channels"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <ChannelsOverview data={formData["4"]} formType={formType} />
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Program Features"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                {type === "credit" ? (
                  <ProgramFeaturesCreditOverview data={formData["5"]} />
                ) : (
                  <ProgramFeaturesOverview data={formData["5"]} />
                )}
              </I2cAccordion>

              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Optional Features"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <OptionalFeaturesOverview data={formData["6"]} />
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Interfaces and Components"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <InterfacesAndComponentsOverview data={formData["7"]} />
              </I2cAccordion>
              <I2cAccordion
                iconStyle="custom"
                iconClose="cs-linear-chevron-down"
                iconOpen="cs-linear-chevron-up"
                summary="Additional Comments"
                variant="borderless"
                className="accordion-container"
                style={{
                  width: "100%",
                  "--accordion-bg": "var(--bg-primary_alt)",
                }}
              >
                <AdditionalCommentsOverview data={formData["8"]} />
              </I2cAccordion>
              {showFormSignature ? (
                <I2cAccordion
                  iconStyle="custom"
                  iconClose="cs-linear-chevron-down"
                  iconOpen="cs-linear-chevron-up"
                  summary="Client Signoff"
                  variant="borderless"
                  className="accordion-container"
                  style={{
                    width: "100%",
                    "--accordion-bg": "var(--bg-primary_alt)",
                  }}
                >
                  <SignoffOverview data={signatureFormData} />
                </I2cAccordion>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewFormSummary;
